
export class Type {
    id: number;
    name:string;
    published:boolean;
    default:number;
    table:string;
    params:any;
}